export function textSplice(before, after) {
    let prefix = 0;
    const max = Math.min(before.length, after.length);
    while (prefix < max && before[prefix] === after[prefix])
        prefix++;
    let suffix = 0;
    while (suffix < max - prefix &&
        before[before.length - 1 - suffix] === after[after.length - 1 - suffix]) {
        suffix++;
    }
    return { cutStart: prefix, cutEnd: before.length - suffix, delta: after.length - before.length };
}
//# sourceMappingURL=text-splice.js.map